import { inject } from '@angular/core';
import { CanMatchFn, Route, Router, UrlSegment } from '@angular/router';

import { map } from 'rxjs';

import { LOCATION } from '@personal-area/common';
import { UserFacade, UserService } from '@personal-area/global/users/services';

export const emailConfirmationGuard: CanMatchFn = (
  route: Route,
  segments: UrlSegment[],
) => {
  const router = inject(Router);
  const userFacade = inject(UserFacade);
  const userService = inject(UserService);
  const location = inject(LOCATION);

  if (!userFacade.loggedUser.isLoaded) {
    userFacade.getUser(userFacade.loggedUser.id);
  }

  const emailConfirmationUrlTree = router.createUrlTree(
    ['/email-confirmation'],
    {
      queryParams: Object.fromEntries(new URLSearchParams(location.search)),
    },
  );
  return userFacade.loggedUser$.pipe(
    map(() =>
      userService.isEmailConfirmationRequired()
        ? emailConfirmationUrlTree
        : true,
    ),
  );
};
